<quill-editor
    [id]="id"
    [(ngModel)]="reply.message.html"
    [modules]="quillHelperService.htmlQuillConfig"
    (onContentChanged)="replyChanged.emit($event)"
    (onEditorCreated)="onEditorCreated($event)"
    placeholder="{{ 'Write a reply' | translate }}"
    format="html">
    <div quill-editor-toolbar [class.is-collapsed]="isToolbarCollapsed" appLogToolbarControlsClick>
        <button
            class="ql-bold"
            tooltip="{{ 'Bold' | translate }}"
            container="body"
            data-control="Bold"
            [attr.aria-label]="'Bold' | translate"
            tabindex="0"></button>

        <button
            class="ql-italic"
            tooltip="{{ 'Italic' | translate }}"
            container="body"
            data-control="Italic"
            [attr.aria-label]="'Italic' | translate"
            tabindex="-1"></button>

        <button
            class="ql-underline"
            tooltip="{{ 'Underline' | translate }}"
            container="body"
            data-control="Underline"
            [attr.aria-label]="'Underline' | translate"
            tabindex="-1"></button>

        <button
            class="ql-strike"
            tooltip="{{ 'Strikethrough' | translate }}"
            container="body"
            data-control="Strikethrough"
            [attr.aria-label]="'Strikethrough' | translate"
            tabindex="-1"></button>

        <select
            class="ql-background quill-tooltip"
            [attr.data-tooltip]="'Background color' | translate"
            [attr.aria-label]="'Background color' | translate"
            data-control="Background color"
            tabindex="-1"></select>

        <select
            class="ql-align quill-tooltip"
            [attr.data-tooltip]="'Alignment' | translate"
            [attr.aria-label]="'Alignment' | translate"
            data-control="Alignment"
            tabindex="-1"></select>

        <select
            class="ql-color quill-tooltip"
            [attr.data-tooltip]="'Text color' | translate"
            [attr.aria-label]="'Text color' | translate"
            data-control="Text color"
            tabindex="-1"></select>

        <!-- Collapse/expand button -->
        <button
            type="button"
            class="toolbar-collapse-btn"
            tooltip="{{ (isToolbarCollapsed ? 'Show formatting' : 'Hide formatting') | translate }}"
            [class.ql-active]="!isToolbarCollapsed"
            [attr.aria-expanded]="!isToolbarCollapsed"
            [attr.aria-label]="(isToolbarCollapsed ? 'Show formatting' : 'Hide formatting') | translate"
            (click)="toggleToolbarControls()"
            container="body"
            data-control="Toggle formatting controls"
            tabindex="0">
            <sb-inline-svg
                class="icon"
                aria-hidden="true"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/More icon.svg'">
            </sb-inline-svg>
        </button>

        <button
            class="ql-list toolbar-secondary"
            tooltip="{{ 'Ordered list' | translate }}"
            container="body"
            data-control="Ordered list"
            value="ordered"
            [attr.aria-label]="'Ordered list' | translate"
            tabindex="-1"></button>

        <button
            class="ql-list toolbar-secondary"
            tooltip="{{ 'Bullet list' | translate }}"
            container="body"
            data-control="Bullet list"
            value="bullet"
            [attr.aria-label]="'Bullet list' | translate"
            tabindex="-1"></button>

        <select
            class="ql-header quill-tooltip toolbar-secondary"
            data-control="Text size"
            [attr.data-tooltip]="'Text size' | translate"
            [attr.aria-label]="'Text size' | translate"
            tabindex="-1">
            <option selected></option>
            <option value="1"></option>
            <option value="2"></option>
            <option value="3"></option>
            <option value="4"></option>
            <option value="5"></option>
            <option value="6"></option>
        </select>

        <button
            class="ql-clean toolbar-secondary"
            tooltip="{{ 'Clean formatting' | translate }}"
            container="body"
            data-control="Clean formatting"
            [attr.aria-label]="'Clean formatting' | translate"
            tabindex="-1"></button>

        <button
            class="ql-blockquote toolbar-secondary"
            tooltip="{{ 'Blockquote' | translate }}"
            container="body"
            data-control="Blockquote"
            [attr.aria-label]="'Blockquote' | translate"
            tabindex="-1"></button>

        <button
            class="ql-link toolbar-secondary"
            tooltip="{{ 'Link' | translate }}"
            container="body"
            data-control="Link"
            [attr.aria-label]="'Link' | translate"
            tabindex="-1"></button>

        <button
            class="ql-image toolbar-secondary"
            tooltip="{{ 'Image' | translate }}"
            container="body"
            data-control="Image"
            [attr.aria-label]="'Image' | translate"
            tabindex="-1"></button>
        <!--            <span class="ql-format-separator"></span>-->
        <!--            <button class="ql-code-block"></button>-->
        <!--            <button class="ql-indent" value="-1"></button>-->
        <!--            <button class="ql-indent" value="+1"></button>-->
        <!--            <button class="ql-direction" value="rtl"></button>-->
    </div>
</quill-editor>
